/*

FILE: accordions.js
DESCRIPTION: Render accordions and handle functionality
AUTHOR(S): R.J. LaCount

*/

import Handorgel from 'handorgel';

const initAccordions = (accordions) => {

	accordions.forEach((item) => {

		const accordion = new Handorgel(item, {
			multiSelectable: false
		});
	});
}

export { initAccordions };
